import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [count, setCount] = useState(1);
  const [prefix, setPrefix] = useState('ALS');
  const [generating, setGenerating] = useState(false);
  const [msg, setMsg] = useState('');

  const load = () => api.get('/admin/coupons').then(r => setCoupons(r.data));
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setGenerating(true);
    setMsg('');
    try {
      const res = await api.post('/admin/coupons/generate', { count, prefix });
      setMsg(`Generated ${res.data.coupons.length} coupon(s)`);
      load();
    } catch {
      setMsg('Generation failed');
    } finally {
      setGenerating(false);
    }
  };

  const deleteCoupon = async (id) => {
    if (!window.confirm('Delete this coupon?')) return;
    try {
      await api.delete(`/admin/coupons/${id}`);
      load();
    } catch (err) {
      alert(err.response?.data?.message || 'Delete failed');
    }
  };

  const copyAll = () => {
    const unused = coupons.filter(c => !c.isUsed).map(c => c.code).join('\n');
    navigator.clipboard.writeText(unused);
    setMsg('Copied unused codes to clipboard!');
  };

  const fmt = (d) => new Date(d).toLocaleDateString();

  return (
    <div>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Coupon Codes</h1>
        <p className="admin-page-sub">{coupons.length} total · {coupons.filter(c => !c.isUsed).length} unused</p>
      </div>

      {/* Generate */}
      <div className="admin-card">
        <div className="admin-card-title">Generate Coupons</div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div className="admin-field" style={{ marginBottom: 0, flex: 1, minWidth: 120 }}>
            <label className="admin-label">Prefix</label>
            <input className="admin-input" value={prefix} onChange={e => setPrefix(e.target.value.toUpperCase())} placeholder="ALS" />
          </div>
          <div className="admin-field" style={{ marginBottom: 0, flex: 1, minWidth: 120 }}>
            <label className="admin-label">Count</label>
            <input className="admin-input" type="number" min={1} max={100} value={count} onChange={e => setCount(Number(e.target.value))} />
          </div>
          <button className="admin-btn" onClick={generate} disabled={generating} style={{ padding: '12px 24px' }}>
            {generating ? 'Generating...' : '+ Generate'}
          </button>
        </div>
        {msg && <p style={{ marginTop: 12, fontSize: 13, color: msg.includes('fail') ? '#f87171' : '#4ade80' }}>{msg}</p>}
      </div>

      {/* List */}
      <div className="admin-toolbar">
        <button className="admin-btn admin-btn-ghost" onClick={copyAll}>📋 Copy Unused Codes</button>
      </div>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr><th>Code</th><th>Status</th><th>Used By</th><th>Expires</th><th>Created</th><th></th></tr>
          </thead>
          <tbody>
            {coupons.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', padding: 32, color: 'rgba(255,255,255,0.3)' }}>No coupons yet</td></tr>
            ) : coupons.map(c => (
              <tr key={c._id}>
                <td style={{ fontFamily: 'monospace', fontSize: 15, fontWeight: 700, letterSpacing: 1, color: '#d4af37' }}>{c.code}</td>
                <td>
                  {c.isUsed
                    ? <span className="badge declined">Used</span>
                    : <span className="badge approved">Available</span>}
                </td>
                <td>{c.usedBy ? `${c.usedBy.fullName} (${c.usedBy.ticketNumber})` : '—'}</td>
                <td>{c.expiresAt ? fmt(c.expiresAt) : '—'}</td>
                <td>{fmt(c.createdAt)}</td>
                <td>
                  {!c.isUsed && (
                    <button className="admin-btn admin-btn-danger" style={{ padding: '5px 12px', fontSize: 12 }} onClick={() => deleteCoupon(c._id)}>
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
